import { Crud } from "./crud";

export class LoginResource extends Crud {

    constructor() {
        super('login');
    }
}